import React, { useEffect, useState } from "react";
import { ADDRESS, ASSIGN, CITY, OFFICE_NAME, PHONE_NO, STATE, ZIP, STATUS, ACTION, OFFICE_LIST, ADD, ASSIGN_DOCTOR, HOME, DASH, OFFICE_STATUS, NAME, ROWS_PER_PAGE, ALL } from "../../Helper/Constants";
import axios from "axios";
import { baseURL } from "../../Config";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import { NavLink, useNavigate } from "react-router-dom";
import { DELETE_OFFICE, OFFICE_LIST_API } from "../../Helper/ApiPath";
import NoDataFound from "../CommonComponent/NoDataFound";
import Loader from "../CommonComponent/Loader";
import { DELETE_OFFICE_MESSAGE } from "../../Helper/Messages";
import Swal from "sweetalert2";

function ManageOffice() {
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();
    const officePagination = JSON.parse(sessionStorage.getItem("officePagination"));
    const [officeList, setOfficeList] = useState([]);
    const [offset, setOffset] = useState(officePagination && officePagination.offset ? officePagination.offset : 1);
    const [rowCount, setRowCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);

    const token = JSON.parse(localStorage.getItem("logToken"));

    const [isLoading, setIsLoading] = useState(true);

    const [filterValues, setFilterValues] = useState({
        search: officePagination && officePagination.search ? officePagination.search : "",
        status: officePagination && officePagination.status ? officePagination.status : "",
    });

    const handleFilterValues = (e) => {
        const { name, value } = e.target;
        setFilterValues({ ...filterValues, [name]: value });
        sessionStorage.setItem(
            "officePagination",
            JSON.stringify({
                ...filterValues,
                [name]: value,
                offset: offset,
            })
        );
        setOffset(1);
        setCurrentPage(0);
    };
    const fetchData = async () => {
        await axios
            .post(`${baseURL}/${OFFICE_LIST_API}`, {
                headers: { authorization: token.token },
                page: offset,
                rowsPerPage: ROWS_PER_PAGE,
                statusId: filterValues.status,
                search: filterValues.search,
            })
            .then((res) => {
                setIsLoading(false);
                setOfficeList(res.data.data);
                setPageCount(res.data.extraData.pageCount);
                setRowCount(res.data.extraData.rowCount);
            })
            .catch((err) => {
                setIsLoading(false);
                if (err.response) {
                    if (err.response.status == 500) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        toast.error(err.response.data.message);
                    }
                }
            });
    };
    const handlePageClick = (event) => {
        sessionStorage.removeItem("officePagination");
        const selectedPage = event.selected;
        setOffset(selectedPage + 1);
        setCurrentPage(selectedPage);
    };

    const handleEdit = (id) => {
        sessionStorage.setItem(
            "officePagination",
            officePagination
                ? JSON.stringify(officePagination)
                : JSON.stringify({
                      offset: offset,
                      search: filterValues.search,
                      status: filterValues.status,
                  })
        );
        navigate("/editOffice");
        localStorage.setItem("officeId", id);
    };

    const handledelete = async (id, statusId) => {
        Swal.fire({
            title: DELETE_OFFICE_MESSAGE,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (result.isConfirmed) {
                    await axios
                        .post(`${baseURL}/${DELETE_OFFICE}`, {
                            headers: { authorization: token.token },
                            officeId: id,
                        })
                        .then((res) => {
                            if (res.status === 200) {
                                fetchData();
                                Swal.fire(res.data.message, " ", "success");
                            }
                        })
                        .catch((err) => {
                            if (err.response) {
                                if (err.response.status == 500) {
                                    localStorage.clear();
                                    navigate("/login");
                                } else {
                                    toast.error(err.response.data.message);
                                }
                            }
                        });
                }
            }
        });
    };

    const handledview = (id) => {
        sessionStorage.setItem(
            "officePagination",
            officePagination
                ? JSON.stringify(officePagination)
                : JSON.stringify({
                      offset: offset,
                      search: filterValues.search,
                      status: filterValues.status,
                  })
        );
        navigate("/ViewOffice");
        localStorage.setItem("officeId", id);
    };

    const handleClick = (e) => {
        e.preventDefault();
        navigate("/addOffice");
    };

    const handleAssign = (id, name) => {
        sessionStorage.removeItem("assignDoctorPagination");

        sessionStorage.setItem(
            "officePagination",
            officePagination
                ? JSON.stringify(officePagination)
                : JSON.stringify({
                      offset: offset,
                      search: filterValues.search,
                      status: filterValues.status,
                  })
        );
        navigate("/assignDoctor");
        localStorage.setItem("officeId", id);
        localStorage.setItem("officeName", name);
    };

    useEffect(() => {
        fetchData();
    }, [offset, filterValues]);

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title">{OFFICE_LIST}</div>
                            </div>
                            <ol className="breadcrumb page-breadcrumb pull-right">
                                <li>
                                    <i className="fa fa-home"></i>&nbsp;
                                    <NavLink className="parent-item" to="/dashboard">
                                        {HOME}
                                    </NavLink>
                                    &nbsp;<i className="fa fa-angle-right"></i>
                                </li>
                                <li className="active">{OFFICE_LIST}</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tabbable-line">
                                <div className="tab-content">
                                    <div className="tab-pane active fontawesome-demo" id="tab1">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card" style={isLoading ? { height: "35rem" } : {}}>
                                                    <div className="card-body ">
                                                        <div className="row">
                                                            <div className="row d-flex justify-content-between">
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="btn-group">
                                                                        <button id="addRow" className="btn btn-info" onClick={handleClick}>
                                                                            {ADD}
                                                                            <i className="fa fa-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                    <div>
                                                                        <div className="btn-group mx-3">
                                                                            <label className="mt-2 col-md-3">{NAME}</label>
                                                                            <input
                                                                                className="form-control mr-sm-2"
                                                                                name="search"
                                                                                type="search"
                                                                                placeholder="Search"
                                                                                aria-label="Search"
                                                                                value={filterValues.search}
                                                                                onChange={handleFilterValues}
                                                                            />
                                                                        </div>

                                                                        <div className="btn-group mx-5">
                                                                            <label className="mt-2 col-md-5">{STATUS}</label>
                                                                            <select className="form-control col-md-3" name="status" value={filterValues.status} onChange={handleFilterValues}>
                                                                                <option value="">{ALL}</option>
                                                                                {Object.keys(OFFICE_STATUS).map((item, i) => {
                                                                                    return (
                                                                                        <option key={i} value={OFFICE_STATUS[item]}>
                                                                                            {item}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="table-scrollable" style={isLoading ? { border: "none" } : {}}>
                                                            <table className="table table-hover table-checkable order-column full-width" id="example4">
                                                                <thead>
                                                                    <tr>
                                                                        <th>{OFFICE_NAME}</th>
                                                                        <th>{PHONE_NO}</th>
                                                                        <th>{ADDRESS}</th>
                                                                        <th>{STATE}</th>
                                                                        <th>{CITY}</th>
                                                                        <th>{ZIP}</th>
                                                                        <th>{STATUS}</th>
                                                                        <th>{ACTION}</th>
                                                                        <th>{ASSIGN}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={isLoading ? { borderStyle: "none", borderColor: "#fff" } : {}}>
                                                                    {isLoading ? (
                                                                        <Loader />
                                                                    ) : (
                                                                        <>
                                                                            {!officeList ? (
                                                                                <>{isLoading ? "" : <NoDataFound />}</>
                                                                            ) : (
                                                                                officeList &&
                                                                                officeList.map((item, index) => {
                                                                                    return (
                                                                                        <tr className="odd gradeX" key={index}>
                                                                                            <td className="left">{item.name ? item.name : DASH}</td>
                                                                                            <td className="left">{item.phoneNo1 ? item.phoneNo1 : DASH}</td>
                                                                                            <td className="left">{item.address ? item.address : DASH}</td>
                                                                                            <td className="left">{item.state ? item.state : DASH}</td>
                                                                                            <td className="left">{item.city ? item.city : DASH}</td>
                                                                                            <td className="left">{item.zip ? item.zip : DASH}</td>

                                                                                            <td className="left">
                                                                                                <span
                                                                                                    className={
                                                                                                        "badge " +
                                                                                                        (item.statusId == 2
                                                                                                            ? "deactiveStatus badge-warning"
                                                                                                            : item.statusId == 1
                                                                                                            ? "activeStatus badge-success"
                                                                                                            : "badge-danger")
                                                                                                    }
                                                                                                >
                                                                                                    {Object.keys(OFFICE_STATUS).find((key) => OFFICE_STATUS[key] === item.statusId)}
                                                                                                </span>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary btn-xs" onClick={() => handleEdit(item.id)}>
                                                                                                    <i className="fa fa-pencil"></i>
                                                                                                </button>

                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-danger btn-xs"
                                                                                                    onClick={() => handledelete(item.id, item.statusId)}
                                                                                                >
                                                                                                    <i className="fa fa-trash-o"></i>
                                                                                                </button>

                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-warning btn-xs"
                                                                                                    onClick={() => handledview(item.id, item.statusId)}
                                                                                                >
                                                                                                    <i className="fa fa-eye"></i>
                                                                                                </button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-circle btn-info"
                                                                                                    onClick={() => handleAssign(item.id, item.name)}
                                                                                                >
                                                                                                    {ASSIGN_DOCTOR}
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex justify-content-between mx-4">
                                                        <div>Total {officeList == null ? "0" : rowCount} Office</div>
                                                        <div className="pagination-center">
                                                            <ReactPaginate
                                                                initialPage={0}
                                                                pageCount={pageCount}
                                                                marginPagesDisplayed={0}
                                                                pageRangeDisplayed={3}
                                                                onPageChange={handlePageClick}
                                                                containerClassName="pagination"
                                                                activeClassName="active"
                                                                pageLinkClassName="page-link"
                                                                breakLinkClassName="page-link"
                                                                nextLinkClassName="page-link"
                                                                previousLinkClassName="page-link"
                                                                pageClassName="page-item"
                                                                breakClassName="page-item"
                                                                nextClassName="page-item"
                                                                previousClassName="page-item"
                                                                previousLabel="Previous"
                                                                nextLabel="Next"
                                                                disableInitialCallback={true}
                                                                forcePage={officePagination && officePagination.offset ? officePagination.offset - 1 : currentPage}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageOffice;
